module.exports = __webpack_public_path__ + "static/img/bird12.403d124.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bird12.png
// module id = ECTi
// module chunks = 1